import { Box, Flex, Heading, Image, Link } from "@chakra-ui/react";
import React from "react";
import GitHubCalendar from "react-github-calendar";
import Fade from "react-reveal/Fade";
const Github = () => {
  return (
    <div
      style={{
        backgroundColor: "teal",
        border: "1px solid black",
        paddingBottom: "20px",
      }}
    >
      <Fade>
        <Heading mb="1rem" textAlign={"center"} backgroundColor={"black"} marginBottom={"30px"}
          height={"100px"} >
          Github Stats
        </Heading>
      </Fade>
      <Fade>
        <Box
          my={"2rem"}
          px={{ base: "1rem", lg: "none" }}
          overflowX={"scroll"}
          sx={{
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box
            width="1000px"
            p="2rem"
            margin={"auto"}
            backgroundColor={"teal"}
            // style={{ backgroundColor: "black" }}
          >
            <GitHubCalendar
              username="prachi913"
              className="react-activity-calendar"
            />
          </Box>
        </Box>
      </Fade>

      <Flex
        flexDir={{ base: "column", lg: "row" }}
        margin={"1rem"}
        align={"center"}
        justify={"center"}
        gap="7"
      >
        <Fade>
          <Box>
            <Link href="https://github.com/prachi913" />
            <Image
              id="github-top-langs"
              width="430px"
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=prachi913&layout=compact&theme=dark"
            />
          </Box>
          <Box>
            <Link href="https://github.com/prachi913" />
            <Image
              id="github-streak-stats"
              width="500px"
              src="https://github-readme-streak-stats.herokuapp.com?user=prachi913&theme=dark"
            />
          </Box>

          <Box>
            <Link href="https://github.com/prachi913" />
            <Image
              width="500px"
              id="github-stats-card"
              src="https://github-readme-stats.vercel.app/api?username=prachi913&count_private=true&show_icons=true&theme=dark"
            />
          </Box>
        </Fade>
      </Flex>
    </div>
  );
};

export { Github };
